module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sky-reveal",
    attrs: {
      "aria-controls": _vm.ariaId
    }
  }, [_c('div', {
    directives: [{
      name: "sky-reveal",
      rawName: "v-sky-reveal",
      value: (_vm.openState),
      expression: "openState"
    }],
    class: ['content', {
      closed: !_vm.openState
    }],
    attrs: {
      "aria-controls": _vm.ariaId,
      "aria-expanded": _vm.ariaExpanded
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._t("default")], 2)]), _vm._v(" "), (_vm.button) ? _c('button', {
    staticClass: "button",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("\r\n\r\n\t\t" + _vm._s(_vm.buttonLabel) + "\r\n\t")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6682bo/master/~/vue-loader/lib/template-compiler.js?{"id":"data-v-ab5c9be4"}!./scripts/sky-reveal/sky-reveal.html
// module id = 263
// module chunks = 1